<template>
  <div class="meet-sub"></div>
</template>

<script>
export default {
  name: "subscriber",

  props: ["stream", "session"],

  mounted() {
    const options = {
      insertMode: "append",
      width: "100%",
      height: "100%"
    };
    const subscriber = this.session.subscribe(
      this.stream,
      this.$el,
      options,
      err => {
        if (err) {
          this.$emit("error", err);
        } else {
          this.$emit("subscriberConnected", subscriber);
        }
      }
    );
    this.$emit("subscriberCreated", subscriber);
  }
};
</script>

<style lang="scss" scoped>
.meet-sub {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>
